<template>
  <div @click.capture="activity_bytouch" id="app">
    <product-attributes-modal />
    <select-menu-modal />
    <countdown-modal
      v-if="showCountdown"
      @onClose="toogleCountdown"
      @onConfirm="reset"
    />
    <sng-popup
      v-if="showSngPopup"
      @close="showSngPopup = false"
      :scanned="sngResult"
    ></sng-popup>
    <router-view @insertedAmountChanged="activity" />
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { VueMasonryPlugin } from "vue-masonry";
Vue.use(VueMasonryPlugin);
import CountdownModal from "@/components/modals/countdown.vue";
import SngPopup from "@/components/modals/sngPopup.vue";

import { cancel, Connector } from "./api/payment";
import { cloneDeep, endsWith, isEmpty } from "lodash";
import {
  addProductToBasket,
  combineProductsToMenu,
  findSameBasketItem,
  productToBasketItem
} from "@/utils/products";
import { productPrice } from "@/utils/pricing";
import { checkSchedules } from "@/utils/schedules";

const TIMER_DURATION_DEFAULT = 40000;
const TIMER_DURATION_LONG = 80000;

export default {
  created() {
    new Connector(this.$store).connect();
    window.global_event_bus.$on("barcodeScanned", this.barcodeScanned);
  },
  beforeDestroy() {
    window.global_event_bus.$off("barcodeScanned", this.barcodeScanned);
  },
  data() {
    return {
      timer: null,
      timer_duration: TIMER_DURATION_DEFAULT,
      showCountdown: false,
      showSngPopup: false,
      sngResult: {}
    };
  },
  components: {
    CountdownModal,
    SngPopup
  },
  computed: {
    ...mapGetters({
      basket: "BASKET",
      schedules: "SCHEDULES",
      deliveryMethods: "DELIVERY_METHODS",
      extras: "EXTRAS",
      menus: "MENUS",
      productByBarcode: "PRODUCT_BY_BARCODE",
      siteSetting: "SITE_SETTING",
      isCikam: "IS_CIKAM",
      terminal: "TERMINAL",
      txid: "TXID",
      locked: "LOCKED"
    })
  },
  methods: {
    ...mapMutations({
      clearBasket: "CLEAR_BASKET",
      setBasket: "SET_BASKET"
    }),
    ...mapActions({
      logRouter: "LOG_ROUTER",
      logAudit: "LOG_AUDIT",
      setPolelight: "SET_POLELIGHT"
    }),
    activity_bytouch() {
      this.activity(true);
    },
    activity(by_touch) {
      if (
        this.$router.currentRoute &&
        this.$router.currentRoute.name === "home"
      ) {
        console.log("captured activity by touch on home, no countdown");
        return;
      }
      if (!by_touch && this.showCountdown) {
        this.showCountdown = false;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (process.env.NODE_ENV === "development") {
        this.timer = setTimeout(this.toogleCountdown, 4000000);
      } else {
        this.timer = setTimeout(this.toogleCountdown, this.timer_duration);
      }
    },
    toogleCountdown() {
      console.log("toggleCountdown");
      if (this.locked) {
        this.showCountdown = false;
      } else {
        this.showCountdown = !this.showCountdown;
      }
    },
    cancelCashPayment() {
      if (this.txid && this.terminal.terminal) {
        cancel(this.txid, this.terminal.terminal);
      } else {
        console.log(
          "cancelCashPayment - cancel failed, txid/terminal missing."
        );
      }
    },
    reset() {
      this.setPolelight("green");
      if (this.isCikam) {
        this.cancelCashPayment();
      }
      this.toogleCountdown();
      this.$selectMenuModal.hide();
      this.$productAttributesModal.hide();
      this.clearBasket();
      this.logAudit({
        category: "PAGE",
        event: "CLOSE",
        data: "timeout"
      });
      this.logRouter({ name: "home", router: this.$router });
    },
    handleCouponBarcode(barcode) {
      console.log("App - handleCouponBarcode" + barcode);
      //TODO add coupon product properties in info popup
      this.sngResult = { success: true, error: "" };
      //this.showSngPopup = true;
    },
    getDefaultScanExtras(basketItem) {
      let result = [];
      if (basketItem.extras) {
        basketItem.extras.forEach(bi => {
          if (bi["default_scan_extra"]) {
            let default_scan_extra = this.extras[bi["default_scan_extra"]];
            if (default_scan_extra) {
              default_scan_extra["default_scan_extra"] = true;
              result.push(default_scan_extra);
            }
          }
        });
      }
      return result;
    },
    addDefaultScanExtra(basketItem) {
      let defaultScanExtras = this.getDefaultScanExtras(basketItem);
      if (defaultScanExtras) {
        basketItem["selectedExtras"] = defaultScanExtras;
        //console.log("### basketItem " + JSON.stringify(basketItem));
      }
    },
    mapProductVariant(product, barcode) {
      let variant = product.variants.find(v => v.barcode === barcode);
      if (!variant) return product;

      // map the scanned variant barcode to the product barcode and price.
      const variantProperties = {
        scannedVariant: {
          scannedBarcode: barcode,
          productBarcode: product.barcode,
          productPrice: product.price,
          variantBarcode: variant.barcode,
          variantPrice: variant.price
        },
        barcode: variant.barcode,
        price: variant.price
      };

      const updatedProduct = { ...product, ...variantProperties };
      console.log("Product variant mapped:", {
        originalProduct: product,
        variant,
        result: updatedProduct
      });

      return updatedProduct;
    },
    handleProductBarcode(barcode) {
      let product = cloneDeep(this.productByBarcode(barcode.barcode));
      if (product !== undefined) {
        product.scanned = 1;
        //console.log("### scanned product:", JSON.stringify(product));
        product = this.mapProductVariant(product, barcode.barcode);

        if (endsWith(product.image, "empty.png") || isEmpty(product.image)) {
          product.image = require("@/assets/barcode.png");
          product.composition_image = require("@/assets/empty.png");
        }
        let basketItem = productToBasketItem(product);

        this.addDefaultScanExtra(basketItem);

        let is_voucher = productPrice(basketItem) < 0.0;
        if (is_voucher && !this.siteSetting.toilet_voucher_enabled) return;
        if (!is_voucher && !this.siteSetting.scan_and_go_enabled) return;
        let existing = findSameBasketItem(basketItem, this.basket);
        if (is_voucher && existing) return; //max 1 negative priced item
        let newBasket = addProductToBasket(basketItem, this.basket);
        newBasket = combineProductsToMenu(this.menus, newBasket);
        this.setBasket(newBasket);
        this.sngResult = { success: true, error: "", product };
        this.showSngPopup = true;
        this.logRouter({ name: "order", router: this.$router });
        this.logAudit({
          category: "CART",
          event: "ADD_PRODUCT",
          data: product
        });
      } else {
        this.sngResult = { success: false, error: "not found", product };
        this.showSngPopup = true;
        console.log("scanned product not found");
      }
    },
    isScanView() {
      let activeRoute = this.$router.currentRoute;
      if (!(activeRoute && activeRoute.name)) {
        return false;
      }
      if (["order", "combo", "menu", "checkout"].includes(activeRoute.name)) {
        return true;
      } else if (activeRoute.name === "home") {
        let activeDeliveryMethods = this.deliveryMethods.filter(item =>
          checkSchedules(this.schedules, item)
        );
        return activeDeliveryMethods && activeDeliveryMethods.length === 1;
      } else {
        return false;
      }
    },
    barcodeScanned(barcode) {
      if (
        !(
          this.siteSetting.scan_and_go_enabled ||
          this.siteSetting.coupon_enabled ||
          this.siteSetting.toilet_voucher_enabled
        )
      ) {
        return;
      }
      if (this.isScanView()) {
        this.activity(false);
        if (barcode.success) {
          if (barcode.verified) {
            this.handleCouponBarcode(barcode);
          } else {
            this.handleProductBarcode(barcode);
          }
        }
      } else {
        console.log("Product or coupon scanned but we are at invalid view.");
      }
    }
  },
  watch: {
    $route(to) {
      if (to && to.name) {
        if (to.name === "home") {
          if (this.timer) {
            this.timer_duration = TIMER_DURATION_DEFAULT;
            clearTimeout(this.timer);
            this.timer = null;
            return;
          }
        }
        if (to.name === "payment") {
          this.timer_duration = TIMER_DURATION_LONG;
        } else {
          this.timer_duration = TIMER_DURATION_DEFAULT;
        }
        this.activity(false);
      }
    }
  }
};
</script>

<style>
.hidden {
  visibility: hidden;
}

.display-none {
  display: none !important;
}

::-webkit-scrollbar {
  display: none;
}

/*noinspection CssUnknownTarget*/
@import url("/orderkiosk/api/css_theme/get_css_vars/");
</style>
